import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtnCloseComponent } from '../../button/btn-close/btn-close.component';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
  selector: 'lib-modal-layout',
  imports: [CommonModule, BtnCloseComponent],
  templateUrl: './modal-layout.component.html',
  styleUrl: './modal-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideNativeDateAdapter()],
})
export class ModalLayoutComponent {
  title = input.required<string>()
  subtitle = input.required<string>()
  submit = input<boolean>()
}
